export default "__VITE_ASSET__ChT6$h1n__"